import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { I18nContext } from './I18nContext';

interface UserContextProviderProps {
  children: ReactNode;
}

export const I18nProvider: React.FC<UserContextProviderProps> = ({ children }) => {
  const { t, i18n } = useTranslation('global');

  return (
    <I18nContext.Provider value={{ t, i18n }}>
      {children}
    </I18nContext.Provider>
  );
};